import React from 'react';
import Contact from './Contact';

const ContactPage = () => {
  return (
    <div className="pt-24">
      <Contact />
    </div>
  );
};

export default ContactPage;